module.exports = __webpack_public_path__ + "img/refresh.595090d4.svg";